import { usePagination } from '@mangovoice/mango-ui'
import type { UsePaginationReturn } from '@mangovoice/mango-ui'

export type UseSwitchboardPaginationReturn = UsePaginationReturn

/**
 * Switchboard-specific re-export of the shared usePagination hook.
 * Preserves the existing public API while delegating to @mangovoice/mango-ui.
 */
export function useSwitchboardPagination(
  totalCount: number,
): UseSwitchboardPaginationReturn {
  return usePagination(totalCount)
}
